import React, { useState } from "react";
import api from "../../../../Axios/api";
import {
  Link,
  Paper,
  Button,
  TextField,
  Container,
  Grid,
  Avatar,
  Modal,
  InputAdornment,
} from "@material-ui/core";

import PinDropIcon from "@material-ui/icons/PinDrop";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Redirect } from "react-router-dom";
import ImageCropProfile from "../../../FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../FormDialog/RemoveProfilePic";
import DeactivateAccount from "../../../FormDialog/DeactivateAccount";
import useStyles from "./styles";
import {
  useUserContext,
  updateProfile,
  logoutUser,
} from "../../../../context/UserContext";

export default function ProfileSettings() {
  const classes = useStyles();
  const { store, dispatch } = useUserContext();
  const token = store.data.token;
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);

  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const [adminData, setAdminData] = useState({
    profilePic: store.data.data.profilePic,
    name: store.data.data.name,
    email: store.data.data.email,
    phoneNumber: store.data.data.phoneNumber,
    address: store.data.data.address,
  });
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [isDeactivatingAccount, setIsDeactivatingAccount] = useState(false);
  // show deactivating Account Dialog
  const handlerAccountDeactivate = (e) => {
    e.preventDefault();
    setIsDeactivatingAccount(true);
  };
  // Deactivate Account Handler
  const confirmedDeactivate = () => {
    setIsDeactivatingAccount(false);

    api
      .patch(
        "/superAdmin/deActivateMyAccount",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(function (res) {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Your Profile has been Deactivated",
          open: true,
        });
        setIsLoggedOut(true);
        return logoutUser(dispatch);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const onSelectlogo = (image) => {
    setAdminData({ ...adminData, profilePic: image });
  };
  const handleChange = (input) => (e) => {
    setAdminData({ ...adminData, [input]: e.target.value });
  };

  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setAdminData({ ...adminData, profilePic: "" });
    setIsProfilePicRemove(false);
  };
  // UPDATE REQUEST SENDING HERE
  const handleSubmitUpdate = () => {
    console.log(adminData);
    api
      .patch(
        "/superAdmin/me",
        {
          ...adminData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {
        const oldData = store.data.data;
        const newData = { ...oldData, ...adminData };

        setTimeout(function () {
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Your Profile has been updated!",
            open: true,
          });
          setTimeout(function () {
            updateProfile(dispatch, newData, token);
          }, 1000);
        }, 1000);
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        })
      );
  };

  // Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);

  const handleOpen = () => {
    setModelOpen(true);
  };

  const handleClose = () => {
    setModelOpen(false);
  };

  return (
    <Grid container className={classes.root}>
      {isLoggedOut ? <Redirect to="/admin/login" /> : ""}
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <Container component="div" maxWidth="sm">
          <div className={classes.paper}>
            <Grid className={classes.settingsSpacing}>
              <form className={classes.form}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Avatar
                    alt="profile photo"
                    src={adminData.profilePic}
                    className={classes.avatarInProfileSetting}
                  >
                    {"LOGO HERE"}
                  </Avatar>
                  <div style={{ marginTop: 50 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpen}
                    >
                      <AddAPhotoIcon
                        style={{
                          marginRight: 5,
                          fontSize: 22,
                          marginBottom: 5,
                        }}
                      />
                      Upload
                    </Button>
                    <Button
                      onClick={handlerRemoveProfilePic}
                      style={{ color: "red" }}
                      color="red"
                    >
                      Remove Image
                    </Button>
                  </div>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={12} lg={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="name"
                      label="Full Name"
                      name="fName"
                      value={adminData.name}
                      onChange={handleChange("name")}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountCircle />
                          </InputAdornment>
                        ),
                      }}
                    ></TextField>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={12} lg={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="email"
                      label="Email"
                      name="email"
                      value={adminData.email}
                      onChange={handleChange("email")}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={12} lg={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="pNumber"
                      label="Phone Number"
                      name="pNumber"
                      value={adminData.phoneNumber}
                      onChange={handleChange("phoneNumber")}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>

                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="address"
                  label="Address"
                  name="address"
                  value={adminData.address}
                  onChange={handleChange("address")}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PinDropIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid container justify="left" spacing={2}>
                  <Grid item>
                    <Link
                      color="primary"
                      component="button"
                      variant="body2"
                      onClick={handlerAccountDeactivate}
                    >
                      Deactivate Account
                    </Link>
                  </Grid>
                </Grid>

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={handleSubmitUpdate}
                >
                  SAVE CHANGES
                </Button>
              </form>
            </Grid>
          </div>
          <DeactivateAccount
            DeactivatingAccount={isDeactivatingAccount}
            setDeactivatingAccount={setIsDeactivatingAccount}
            confirmedDeactivate={confirmedDeactivate}
          />
          <RemoveProfilePic
            RemoveProfilePic={isProfilePicRemove}
            setRemoveProfilePic={setIsProfilePicRemove}
            confirmedRemoveProfilePic={confirmedRemoveProfilePic}
          />

          <Snackbar
            open={open}
            anchorOrigin={{ vertical, horizontal }}
            autoHideDuration={3000}
            onClose={handleCloseSnackBar}
            key={vertical + horizontal}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              onClose={handleCloseSnackBar}
              severity={snackBarstate.type}
            >
              {snackBarstate.message}
            </MuiAlert>
          </Snackbar>
        </Container>
      </Grid>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClose}
          />
        </div>
      </Modal>
    </Grid>
  );
}
